import React, { useState, useEffect } from "react";
import axios from "axios";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import "bootstrap-icons/font/bootstrap-icons.css";
import Swal from "sweetalert2";
import { Form, Modal } from "react-bootstrap";
import { Row, Col, Container, Card } from "react-bootstrap";
import Pagination from 'react-bootstrap/Pagination';

const Withdraw = () => {
  const [loading, setLoading] = useState(false);
  const [withdrawals, setWithdrawals] = useState([]);
  const [TransactionId, setTransactionId] = useState([]);
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [totalWithdraw, setTotalWithdraw] = useState(0);
  const [totalSuccessAmount, setTotalSuccessAmount] = useState(0);
  const [totalPendingAmount, setTotalPendingAmount] = useState(0);
  const [totalRejectedAmount, setTotalRejectedAmount] = useState(0);
  const [activeTab, setActiveTab] = useState("total");
  const [searchQuery, setSearchQuery] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [transactionToReject, setTransactionToReject] = useState(null);
  const [showRejectionModal, setShowRejectionModal] = useState(false);
  const [amount, setAmount] = useState(0);
  const guestId = localStorage.getItem("userid");
  const [rejectionReason, setRejectionReason] = useState("");
  const [customReason, setCustomReason] = useState("");

  const handleOpenModal = (transaction) => {
    setSelectedTransactionId(transaction._id);
    setSelectedAmount(transaction.amount);
    setShowModal(true);
  };

  useEffect(() => {
    loadWithdrawals();
  }, []);

  const rejectionOptions = [
    "-- Select Remark --",
    "ROLLOVER",
    "NOT COMPLETE",
    "YOU HAVE MADE PAYMENT IN OUR OLD ACCOUNT",
    "PLEASE CONTACT CUSTOMER SUPPORT",
    "PAYMENT NOT RECEIVED IN BANK",
    "REPEAT PAYMENT SLIP",
    "UPLOAD PROPER SCREENSHOT WITH UTR",
    "Custom"
  ];

  const loadWithdrawals = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        // "https://api.Cash365days.in/user/transaction-history"
         `${process.env.REACT_APP_API_URL}/user/transaction-history`
      );

      const transactions = response.data.transactions || [];
      const filteredWithdrawals = transactions.filter(
        (transaction) => transaction.type === "Withdraw"
      );

      setWithdrawals(filteredWithdrawals);
      setTotalWithdraw(response.data.totalWithdrawal);

      const ids = filteredWithdrawals.map((transaction) => transaction._id);
      setTransactionId(ids);

      const successAmount = filteredWithdrawals
        .filter((transaction) => transaction.status === "Success")
        .reduce((acc, transaction) => acc + transaction.amount, 0);

      const pendingAmount = filteredWithdrawals
        .filter((transaction) => transaction.status === "Pending")
        .reduce((acc, transaction) => acc + transaction.amount, 0);

      const rejectedAmount = filteredWithdrawals
        .filter((transaction) => transaction.status === "Rejected")
        .reduce((acc, transaction) => acc + transaction.amount, 0);

      setTotalSuccessAmount(successAmount);
      setTotalPendingAmount(pendingAmount);
      setTotalRejectedAmount(rejectedAmount);
    } catch (error) {
      console.error("❌ Error fetching withdrawal transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRejectWithReason = async () => {
    const finalReason = rejectionReason === "Custom" ? customReason : rejectionReason;

    if (!finalReason || finalReason.trim() === "") {
      Swal.fire("Error!", "Please provide a rejection reason.", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        // "https://api.Cash365days.in/admin/approveTransaction",
        `${process.env.REACT_APP_API_URL}/admin/approveTransaction`,
        {
          transactionId: transactionToReject,
          status: "Rejected",
          rejectionReason: finalReason,
        }
      );

      if (response.data.success) {
        console.log("✅ Transaction rejected successfully:", response.data);
        loadWithdrawals(); // refresh the list or UI
      } else {
        console.error("❌ Rejection failed:", response.data.message);
        Swal.fire("Failed", response.data.message || "Rejection failed", "error");
      }
    } catch (error) {
      console.error("❌ Error rejecting transaction:", error);
      Swal.fire("Error!", "An error occurred while rejecting the transaction.", "error");
    } finally {
      setLoading(false);
      setShowRejectionModal(false);
      setRejectionReason("");
      setCustomReason(""); // reset custom input
      setTransactionToReject(null);
    }
  };

  const handleApprove = async (transactionId, newStatus) => {
    setLoading(true);

    try {
      // Find the transaction in the withdrawals array
      const transaction = withdrawals.find(t => t._id === transactionId);

      if (!transaction) {
        console.error("❌ Transaction not found");
        setLoading(false);
        return;
      }

      // Check if the transaction is already in the desired state
      if (transaction.status === newStatus) {
        console.log("ℹ️ Transaction is already in the desired state");
        setLoading(false);
        return;
      }

      if (newStatus === "Rejected") {
        setTransactionToReject(transactionId);
        setShowRejectionModal(true);
        return;
      }

      if (transaction.status === "Rejected" && newStatus === "Success") {
        Swal.fire("Error!", "A rejected transaction cannot be marked as successful.", "error");
        setLoading(false);
        return;
      }
      if (transaction.status === "Success" && newStatus === "Pending") {
        Swal.fire("Error!", "A success transaction cannot be marked as pending.", "error");
        setLoading(false);
        return;
      }
      if (transaction.status === "Rejected" && newStatus === "Success") {
        Swal.fire("Error!", "A rejected transaction cannot be marked as pending.", "error");
        setLoading(false);
        return;
      }
      if (transaction.status === "Rejected" && newStatus === "Pending") {
        Swal.fire("Error!", "A rejected transaction cannot be marked as pending.", "error");
        setLoading(false);
        return;
      }

      // Allow "Pending" to transition to "Rejected"
      if (transaction.status === "Pending" && newStatus === "Rejected") {
        // Optionally, ask for confirmation before rejecting
        const { isConfirmed } = await Swal.fire({
          title: "Are you sure?",
          text: "Do you want to reject this transaction?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, Reject",
          cancelButtonText: "Cancel",
        });

        if (!isConfirmed) {
          setLoading(false);
          return;
        }
      }

      // Proceed with the status change via API
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}admin/approveTransaction`,
        { transactionId, status: newStatus }
      );

      if (response.data.success) {
        console.log("✅ Transaction status updated successfully:", response.data);
        loadWithdrawals(); // Refresh the list after update
      } else {
        console.error("❌ Status update failed:", response.data.message);
        Swal.fire("Error!", response.data.message || "Status update failed", "error");
      }
    } catch (error) {
      console.error("❌ Error updating transaction status:", error);
      Swal.fire("Error!", "An error occurred while updating transaction status.", "error");
    } finally {
      setLoading(false);
    }
  };


  const handleDelete = async (transactionId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await axios.delete(
            `${process.env.REACT_APP_API_URL}user/delete-transaction/${transactionId}`
          );

          if (response.data.success) {
            Swal.fire("Deleted!", "Transaction has been deleted.", "success");
            loadWithdrawals();
          } else {
            Swal.fire("Error!", response.data.message, "error");
          }
        } catch (error) {
          console.error("Error deleting transaction:", error);
          Swal.fire("Error!", "Failed to delete transaction.", "error");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handleCopyBank = (transaction) => {
    const bankDetails = `
      Bank Name: ${transaction.bankName}
      Account Number: ${transaction.accountNumber}
      Account Holder Name: ${transaction.accountHolderName}
      IFSC Code: ${transaction.ifscCode}
      Amount: ${transaction.amount}
      Remark: ${transaction.remark}
    `;

    navigator.clipboard
      .writeText(bankDetails)
      .then(() => {
        alert("Bank details copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy bank details:", err);
        alert("Failed to copy bank details.");
      });
  };

  const handleCopyValue = (value, event) => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        const { clientX, clientY } = event;
        const tooltip = document.getElementById("copy-tooltip");

        tooltip.style.left = `${clientX + 10}px`;
        tooltip.style.top = `${clientY + 10}px`;
        tooltip.style.display = "block";

        setTimeout(() => {
          tooltip.style.display = "none";
        }, 1000);
      })
      .catch((err) => {
        console.error("Failed to copy value:", err);
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}admin/updateAmountByAdmin`,
        {
          userId: guestId,
          _id: selectedTransactionId,
          amount: parseFloat(selectedAmount),
        }
      );

      if (response.data.success) {
        Swal.fire("Success!", response.data.message, "success");
        setShowModal(false);
        loadWithdrawals();
      } else {
        Swal.fire("Error!", response.data.message, "error");
      }
    } catch (error) {
      console.error("❌ Error updating amount:", error);
      Swal.fire("Error!", "Failed to update amount.", "error");
    } finally {
      setLoading(false);
    }
  };

  const filteredWithdrawals = withdrawals.filter((transaction) => {
    // Filter by tab
    if (activeTab !== "total" && transaction.status.toLowerCase() !== activeTab) {
      return false;
    }
    // Filter by search query
    if (
      searchQuery &&
      !transaction.userName.toLowerCase().includes(searchQuery.toLowerCase())
    ) {
      return false;
    }
    return true;
  });

  // Paginate the filtered transactions
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentWithdrawals = filteredWithdrawals.slice(indexOfFirstItem, indexOfLastItem);
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };


  return (
    <div className="profile-container">
      <div
        id="copy-tooltip"
        style={{
          position: "fixed",
          display: "none",
          backgroundColor: "rgba(0, 0, 0, 0.75)",
          color: "#fff",
          padding: "4px 8px",
          borderRadius: "4px",
          fontSize: "12px",
          zIndex: 1000,
        }}
      >
        Copied!
      </div>
      <Row className="g-4">
        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            style={{ cursor: "pointer" }}
            onClick={() => setActiveTab("total")}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-wallet2 fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Total</Card.Title>
                <Card.Text className="cardtext">{totalWithdraw}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            style={{ cursor: "pointer" }}
            onClick={() => setActiveTab("success")}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-wallet2 fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Success</Card.Title>
                <Card.Text className="cardtext">{totalSuccessAmount}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            style={{ cursor: "pointer" }}
            onClick={() => setActiveTab("pending")}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-wallet2 fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Pending</Card.Title>
                <Card.Text className="cardtext">{totalPendingAmount}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            style={{ cursor: "pointer" }}
            onClick={() => setActiveTab("rejected")}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-wallet2 fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Rejected</Card.Title>
                <Card.Text className="cardtext">{totalRejectedAmount}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="table-responsive tablemargin">
        <div className="d-flex justify-content-between">
          <p className="text-start mt-4 requesthistory">Withdraw Transactions</p>

          <div className="d-flex align-items-center">
            <div className="input-group mt-3">
              <span className="input-group-text">
                <i className="bi bi-search"></i>
              </span>
              <input
                type="text"
                placeholder="Search by user name"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>

        {loading ? (
          <div className="text-center my-3">
            <Spinner animation="border" role="status" />
            <p>Loading...</p>
          </div>
        ) : (
          <Table striped bordered hover className="tablehistory position-relative">
            <thead className="text-center">
              <tr className="tablehead text-center">
                <th>#</th>
                <th>User Name</th>
                <th>Amount</th>
                <th>Account Holder Name</th>
                <th>Bank Name</th>
                <th>Account Number</th>
                <th>IFSC Code</th>
                <th>Remark</th>
                {/* <th>Slip Image</th> */}
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="tbodyhistroy">
              {currentWithdrawals.length > 0 ? (
                currentWithdrawals.map((transaction, index) => (
                  <tr className="text-center" key={transaction._id}>
                    <td>{index + indexOfFirstItem + 1}</td>
                    <td
                      className="capitalize-text"
                      onClick={(e) => handleCopyValue(transaction.userName, e)}
                    >
                      {transaction.userName || "N/A"}
                    </td>
                    <td
                      className="capitalize-text"
                      onClick={(e) => handleCopyValue(transaction.amount, e)}
                    >
                      {transaction.amount}
                    </td>
                    <td
                      className="capitalize-text"
                      onClick={(e) => handleCopyValue(transaction.accountHolderName, e)}
                    >
                      {transaction.accountHolderName || "N/A"}
                    </td>
                    <td
                      className="capitalize-text"
                      onClick={(e) => handleCopyValue(transaction.bankName, e)}
                    >
                      {transaction.bankName || "N/A"}
                    </td>
                    <td
                      className="capitalize-text"
                      onClick={(e) => handleCopyValue(transaction.accountNumber, e)}
                    >
                      {transaction.accountNumber || "N/A"}
                    </td>
                    <td
                      className="capitalize-text"
                      onClick={(e) => handleCopyValue(transaction.ifscCode, e)}
                    >
                      {transaction.ifscCode || "N/A"}
                    </td>
                    <td
                      className="capitalize-text"
                      onClick={(e) => handleCopyValue(transaction.remark, e)}
                    >
                      {transaction.remark || "N/A"}
                    </td>

                    <td>
                      <select
                        className={`status-select text-white ${transaction.status.toLowerCase()}`}
                        value={transaction.status}
                        onChange={(e) => handleApprove(transaction._id, e.target.value)}
                      >
                        <option value="Pending" className="pending-option">Pending</option>
                        <option value="Success" className="success-option">Success</option>
                        <option value="Rejected" className="rejected-option">Rejected</option>
                      </select>
                    </td>
                    <td>
                      <Button
                        className="buttonAction me-1"
                        variant="success"
                        size="sm"
                        onClick={() => handleCopyBank(transaction)}
                        title="Copy Bank Details"
                      >
                        <i className="bi bi-copy"></i>
                      </Button>
                      <Button
                        variant="primary"
                        className="buttonAction mx-1"
                        onClick={() => handleOpenModal(transaction)}
                      >
                        <i className="bi bi-pencil-square"></i>
                      </Button>
                    </td>
                  </tr>

                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center nodataavl">
                    No withdrawal transactions available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}

        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Update User Balance</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  type="number"
                  value={selectedAmount}
                  onChange={(e) => setSelectedAmount(e.target.value)}
                  required
                  min="0.01"
                  step="0.01"
                />
              </Form.Group>
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
              </Button>
            </Form>
          </Modal.Body>
        </Modal>


      </div>

      <Row className="">
        <Pagination className="justify-content-center">
          <Pagination.First onClick={() => setCurrentPage(1)} />
          <Pagination.Prev onClick={handlePrevPage} />

          {/* Always show the first two pages */}
          {[...Array(Math.min(2, totalPages))].map((_, index) => (
            <Pagination.Item
              key={index}
              active={index + 1 === currentPage}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}

          {/* Show ellipsis if current page is beyond the first two pages */}
          {currentPage > 3 && <Pagination.Ellipsis disabled />}

          {/* Show current page and its neighbors */}
          {currentPage > 2 && currentPage < totalPages - 1 && (
            <>
              <Pagination.Item
                active
                onClick={() => setCurrentPage(currentPage)}
              >
                {currentPage}
              </Pagination.Item>
            </>
          )}

          {/* Show ellipsis if current page is not near the end */}
          {currentPage < totalPages - 2 && <Pagination.Ellipsis disabled />}

          {/* Always show the last two pages */}
          {[...Array(Math.min(2, totalPages))].map((_, index) => {
            const pageNumber = totalPages - 1 - index;
            return (
              pageNumber > 1 && (
                <Pagination.Item
                  key={pageNumber}
                  active={pageNumber === currentPage}
                  onClick={() => setCurrentPage(pageNumber)}
                >
                  {pageNumber}
                </Pagination.Item>
              )
            );
          }).reverse()}

          <Pagination.Next onClick={handleNextPage} />
          <Pagination.Last onClick={() => setCurrentPage(totalPages)} />
        </Pagination>
      </Row>

      <Modal show={showRejectionModal} onHide={() => setShowRejectionModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Provide Rejection Reason</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Select Remark</Form.Label>
              <Form.Select
                value={rejectionReason}
                onChange={(e) => setRejectionReason(e.target.value)}
                required
              >
                {rejectionOptions.map((reason, index) => (
                  <option key={index} value={reason === "-- Select Remark --" ? "" : reason}>
                    {reason}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {rejectionReason === "Custom" && (
              <Form.Group className="mb-3">
                <Form.Label>Custom Reason</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={customReason}
                  onChange={(e) => setCustomReason(e.target.value)}
                  placeholder="Enter custom reason"
                  required
                />
              </Form.Group>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRejectionModal(false)}>
            Cancel
          </Button>
          {/* <Button
            variant="primary"
            onClick={() => handleRejectWithReason(rejectionReason === "Custom" ? customReason : rejectionReason)}
            disabled={loading}
          >
            {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
          </Button> */}
          <Button
            variant="primary"
            onClick={handleRejectWithReason}
            disabled={
              loading ||
              rejectionReason === "" ||
              (rejectionReason === "Custom" && customReason.trim() === "")
            }
          >
            {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
          </Button>

        </Modal.Footer>
      </Modal>

      <footer className="text-center p-3 bg-light mt-3">
        <p className="mb-0">
          &copy; Cash 365 Days. All Rights Reserved.
        </p>
        {/* <p className="mb-0">
          &copy; {new Date().getFullYear()} Your Company Name. All Rights Reserved.
        </p> */}
      </footer>
    </div>
  );
};

export default Withdraw;